var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.tabList, function (item, $index) {
            return _c(
              "span",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: `${item.permissson}`,
                    expression: "`${item.permissson}`",
                  },
                ],
                key: item.permissson,
                class: ["tabItem", _vm.active === $index ? "active" : ""],
                on: {
                  click: function ($event) {
                    return _vm.changeType($index, item.permissson)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(item.name) +
                    " (" +
                    _vm._s(item.type === 10000 ? _vm.listTotal : _vm.tabTotal) +
                    ") "
                ),
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "opt" },
          [
            _c(
              "div",
              { staticClass: "search" },
              [
                _c(
                  "el-popover",
                  {
                    ref: "popover",
                    staticClass: "searchPop",
                    attrs: {
                      placement: "top",
                      title: "批量搜索",
                      trigger: "click",
                      width: "378",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "close",
                        on: { click: _vm.closeSearchPanel },
                      },
                      [_c("i", { staticClass: "el-icon-close" })]
                    ),
                    _c("base-muti-input", {
                      ref: "baseMutiInput",
                      attrs: { default: _vm.referenceNumber },
                      model: {
                        value: _vm.referenceNumber,
                        callback: function ($$v) {
                          _vm.referenceNumber = $$v
                        },
                        expression: "referenceNumber",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          margin: "16px 0 0",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.handleEmpty },
                          },
                          [_vm._v("清空")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sure",
                            on: { mousedown: _vm.handleConfirm },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-input", {
                  staticClass: "input-search",
                  attrs: {
                    value: _vm.filterList.numbers,
                    placeholder: "请输入提单号/账单号/柜号搜索",
                  },
                  on: { focus: _vm.handleFocus },
                }),
                _c(
                  "div",
                  {
                    staticClass: "btn-search",
                    on: { click: _vm.handleConfirm },
                  },
                  [_c("i", { staticClass: "el-icon-search" })]
                ),
              ],
              1
            ),
            [10000, 1, 2, 3].indexOf(_vm.tabActive) > -1
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.computedPermissions("导出"),
                        expression: "computedPermissions('导出')",
                      },
                    ],
                    staticClass: "derive_a flex_c_c",
                    attrs: { "v-permissson": _vm.computedPermissions("导出") },
                    on: { click: _vm.exportOrigin },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/bill/import.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" 导出 "),
                  ]
                )
              : _vm._e(),
            _vm.tabActive === 2
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.computedPermissions("生成账单"),
                        expression: "computedPermissions('生成账单')",
                      },
                    ],
                    staticClass: "add flex_c_c",
                    staticStyle: { width: "100px" },
                    attrs: {
                      "v-permissson": _vm.computedPermissions("生成账单"),
                    },
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible8 = true
                      },
                    },
                  },
                  [_vm._v(" 生成账单 ")]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "derive_a flex_c_c",
                staticStyle: { padding: "0 12px" },
                on: {
                  click: function ($event) {
                    _vm.dialogVisible9 = true
                  },
                },
              },
              [_vm._v(" 自定义列表 ")]
            ),
            _c(
              "el-upload",
              {
                staticClass: "upload-demo",
                attrs: {
                  action: "/api/Payable/importPayableValidate?type=0",
                  headers: _vm.headers,
                  "on-success": _vm.handleSuccess,
                  "on-error": _vm.handleError,
                  "file-list": _vm.fileList,
                  "show-file-list": false,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "derive_a flex_c_c",
                    staticStyle: { width: "100px" },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/bill/upload.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" 导入模板 "),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "derive_a flex_c_c",
                staticStyle: { width: "100px" },
                on: { click: _vm.donwloadFile },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/bill/import.png"),
                    alt: "",
                  },
                }),
                _vm._v(" 下载模板 "),
              ]
            ),
            _c(
              "BaseFilter",
              {
                attrs: {
                  isActive: _vm.isActive,
                  width: 494,
                  isEmptyBorder: true,
                },
                on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c("SelectFilter", {
                      ref: "selectFilter",
                      attrs: {
                        filterListJson: _vm.filterListJson,
                        filterListId: _vm.filterListId,
                        companyDrapdown: _vm.companyDrapdown,
                        pickUpOptions: _vm.pickUpOptions,
                        clearenceOptions: _vm.clearenceOptions,
                        originOptions: _vm.originOptions,
                        destinationOptions: _vm.destinationOptions,
                        supplierOptions: _vm.supplierOptions,
                        userOptions: _vm.userOptions,
                        tableCode: _vm.tableCode,
                      },
                      on: {
                        ok: function ($event) {
                          return _vm.getFilter()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _c(
            "el-tabs",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "el-tabs",
              attrs: { type: "border-card" },
              on: {
                "tab-click": function ($event) {
                  return _vm.initList()
                },
              },
              model: {
                value: _vm.tabActive,
                callback: function ($$v) {
                  _vm.tabActive = $$v
                },
                expression: "tabActive",
              },
            },
            [
              _vm.active
                ? _vm._l(_vm.childTabList, function (item) {
                    return _c("el-tab-pane", {
                      key: item.type,
                      attrs: {
                        label: `${item.name}(${
                          item.type === 10000
                            ? _vm.tabTotal
                            : _vm.tabNumer.find((a) => a.type === item.type - 1)
                                ?.qty || 0
                        })`,
                        name: item.type,
                      },
                    })
                  })
                : _vm._e(),
              _vm.height !== 0
                ? _c("BaseTable", {
                    key: _vm.active,
                    attrs: {
                      height: _vm.height,
                      tableData: {
                        ..._vm.tableData,
                        fileds: _vm.fileds,
                      },
                      pageIndex: _vm.pager.pageIndex,
                      pageSize: _vm.pager.pageSize,
                      loading: _vm.loading,
                      pageSizes: [20, 30, 50, 100],
                      isEmptyBorder: true,
                    },
                    on: {
                      handlePageChange: _vm.handlePageChange,
                      handleSelectionChange: _vm.handleSelectionChange,
                      sortChange: _vm.sortChange,
                      dblclick: _vm.dblclick,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "blNo",
                          fn: function (row) {
                            return [
                              _vm._v(" " + _vm._s(row.scope.blNo) + " "),
                              !row.scope.invoiceType
                                ? _c("img", {
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      src: require("@/assets/images/const/viewBill.png"),
                                      title: "跟进记录",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewlog(row.scope)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "status",
                          fn: function (row) {
                            return [
                              row.scope.status === 0
                                ? _c("div", { staticClass: "status status1" }, [
                                    _vm._v(
                                      " " + _vm._s(row.scope.statusName) + " "
                                    ),
                                  ])
                                : row.scope.status === 5
                                ? _c("div", { staticClass: "status status2" }, [
                                    _vm._v(
                                      " " + _vm._s(row.scope.statusName) + " "
                                    ),
                                  ])
                                : _c("div", { staticClass: "status status3" }, [
                                    _vm._v(_vm._s(row.scope.statusName)),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "defrayStatusName",
                          fn: function (row) {
                            return [
                              row.scope.defrayStatus === 0
                                ? _c("div", { staticClass: "status status1" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(row.scope.defrayStatusName) +
                                        " "
                                    ),
                                  ])
                                : row.scope.defrayStatus === 1
                                ? _c("div", { staticClass: "status status2" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(row.scope.defrayStatusName) +
                                        " "
                                    ),
                                  ])
                                : _c("div", { staticClass: "status status3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(row.scope.defrayStatusName) +
                                        " "
                                    ),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "opt",
                          fn: function (row) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.active === 0,
                                      expression: "active === 0",
                                    },
                                  ],
                                  ref: `popover${row.scope.id}`,
                                  attrs: {
                                    placement: "bottom-start",
                                    "popper-class": "pop-table-opt",
                                    width: "114",
                                    trigger: "click",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "table-opt" }, [
                                    _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "opt-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.detail(row.scope)
                                            },
                                          },
                                        },
                                        [_vm._v("录入")]
                                      ),
                                    ]),
                                  ]),
                                  _c("img", {
                                    staticStyle: { "margin-left": "-14px" },
                                    attrs: {
                                      slot: "reference",
                                      src: require("@/assets/images/table/opt.png"),
                                    },
                                    slot: "reference",
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "clearenceType",
                          fn: function (row) {
                            return [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("span", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "clearenceType",
                                        class: `clearenceType${row.scope.clearenceType}`,
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.config.clearenceTypeOptions.find(
                                              (a) =>
                                                a.value ===
                                                row.scope.clearenceType
                                            ).label
                                          ) + " "
                                        ),
                                      ]
                                    ),
                                    row.scope.clearenceSupplier
                                      ? _c(
                                          "span",
                                          { staticClass: "supplier" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                row.scope.clearenceSupplier
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "pickUpType",
                          fn: function (row) {
                            return [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("span", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "pickUpType",
                                        class: `pickUpType${row.scope.pickUpType}`,
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.config.pickUpTypeOptions.find(
                                              (a) =>
                                                a.value === row.scope.pickUpType
                                            ).label
                                          ) + " "
                                        ),
                                      ]
                                    ),
                                    row.scope.pickUpSupplier
                                      ? _c(
                                          "span",
                                          { staticClass: "supplier" },
                                          [
                                            _vm._v(
                                              _vm._s(row.scope.pickUpSupplier)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "custom-total",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "custom-total" }, [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("div", { staticClass: "select" }, [
                                      _vm._v(
                                        "已选 " +
                                          _vm._s(_vm.selectionItem.length) +
                                          " 项"
                                      ),
                                    ]),
                                    _vm.active === 0
                                      ? _c("div", { staticClass: "total" }, [
                                          _vm._v(" 应付合计："),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.totalAmount) + " USD"
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm.selectionItem.length && _vm.active === 0
                                      ? _c("div", {
                                          staticClass: "total",
                                          domProps: {
                                            innerHTML: _vm._s(_vm.totalHtml),
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.active
                                      ? _c(
                                          "div",
                                          { staticClass: "total" },
                                          [
                                            _vm._v(" 总金额 "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#fe453d",
                                                  "font-weight": "bold",
                                                  "line-height": "40px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.tabTotalAmount
                                                        .totalAmount
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm.tabActive > 3 &&
                                            _vm.tabActive !== 10000
                                              ? [
                                                  _vm._v(
                                                    "     核销金额合计： "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#fe453d",
                                                        "font-weight": "bold",
                                                        "line-height": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.tabTotalAmount
                                                              .verifedAmount
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm.tabActive === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "batchCounterAudit flex_c_c",
                                            on: { click: _vm.handleBatch },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/images/const/batchCounterAudit.png"),
                                              },
                                            }),
                                            _vm._v(" 批量审核 "),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.tabActive === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "batchCounterAudit flex_c_c",
                                            on: { click: _vm.batchDeleteRow },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/images/const/batchCounterAudit.png"),
                                              },
                                            }),
                                            _vm._v(" 批量删除 "),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.tabActive === 2
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "batchCounterAudit flex_c_c",
                                            on: { click: _vm.counteraudit },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/images/const/batchCounterAudit.png"),
                                              },
                                            }),
                                            _vm._v(" 批量反审核 "),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3899862006
                    ),
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c("AddBillDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible3,
          dialogType: _vm.dialogType,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible3 = false
          },
          ok: _vm.ok,
        },
      }),
      _c("CopeWithDetailDialog", {
        attrs: { dialogVisible: _vm.dialogVisible4, rowData: _vm.rowData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible4 = false
          },
          ok: _vm.ok2,
        },
      }),
      _c("SupplierRecognitionDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
      _c("ExportCopeWith", {
        attrs: {
          dialogVisible: _vm.dialogVisible5,
          filter: {
            ..._vm.formatterFilter(),
            status:
              _vm.active === 0 || _vm.tabActive === 10000
                ? undefined
                : +_vm.tabActive - 1,
          },
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible5 = false
          },
        },
      }),
      _c("FilterDetailDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible6,
          filter: {
            ..._vm.formatterFilter(),
            status:
              _vm.active === 0 || _vm.tabActive === 10000
                ? undefined
                : +_vm.tabActive - 1,
          },
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible6 = false
          },
        },
      }),
      _c("follow-up-records-drawer", {
        attrs: {
          drawer: _vm.drawer,
          rowData: {
            ..._vm.rowData,
            id: _vm.rowData.mblId,
            status: 4,
          },
          "bill-type": 1,
        },
        on: {
          close: function ($event) {
            _vm.drawer = false
          },
        },
      }),
      _c("UploadFileCheckDataDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible7,
          fileData: _vm.fileData,
          type: 1,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible7 = false
          },
          ok: function ($event) {
            _vm.dialogVisible7 = false
            _vm.getList(_vm.pager)
          },
        },
      }),
      _c("CreateBillDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible8,
          type: 1,
          filterList: {
            ..._vm.formatterFilter(),
            status:
              _vm.active === 0 || _vm.tabActive === 10000
                ? undefined
                : +_vm.tabActive - 1,
          },
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible8 = false
          },
          ok: function ($event) {
            _vm.dialogVisible8 = false
            _vm.getList(_vm.pager)
          },
        },
      }),
      _c("CustomerListDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible9,
          useFildList: _vm.useFildListForTab,
          useLogId: _vm.useLogId,
          tabCode: _vm.tabCode,
          tableCode: _vm.tableCode,
        },
        on: {
          ok: function ($event) {
            _vm.dialogVisible9 = false
            _vm.getUserUseLog()
          },
          cancel: function ($event) {
            _vm.dialogVisible9 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }